import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TaskPriorityService from "../../src/Services/TaskPriority.service";
const TaskPriorityLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "label",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<TaskPriority[]>' is not assignable to type '(ids: string[]) => Promise<TaskPriority[]>'.
        fetchItemsById: (ids) => {
            return TaskPriorityService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TaskPriorityService.searchAll(search);
        },
        optionRenderer: function optionRenderer(taskPriorities) {
            return _jsx("span", { children: taskPriorities.label });
        },
    });
};
export default TaskPriorityLookup;
